import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { PrescriptionMedication } from "src/api/types";
import PointerChip from "src/components/PointerChip";
import { useIsMobile } from "src/hooks/useIsMobile";
import glp1Needle from "src/assets/glp1Needle.png";
import { useMedicationInstructions } from "src/hooks/useMedicationInstruction";

interface Props {
  detail: PrescriptionMedication;
  selected: number;
}

const SyringeWithUnits = ({ detail, selected }: Props) => {
  const isMobile = useIsMobile();
  const { amount } = useMedicationInstructions(detail, selected);

  return (
    <Stack gap={isMobile ? 2 : 1}>
      <PointerChip>
        <Typography color="#ffffff" fontWeight={600} textAlign="center">
          {amount}
        </Typography>
      </PointerChip>
      <Box alignSelf="center">
        <img
          src={glp1Needle}
          alt="Needle"
          width={isMobile ? 260 : 441}
          height={isMobile ? 80 : 119}
        />
      </Box>
    </Stack>
  );
};

export default SyringeWithUnits;
